module.exports = __webpack_public_path__ + "static/media/mc_acc_opt_70_1x.87d3dda0.png";